import { useEffect } from 'react';

interface StructuredDataProps {
  type: 'Organization' | 'SoftwareApplication' | 'WebPage' | 'Product' | 'Article' | 'BreadcrumbList' | 'FAQPage' | 'Blog' | 'ItemList';
  data: Record<string, any>;
  id?: string;
}

const StructuredData = ({ type, data, id }: StructuredDataProps) => {
  useEffect(() => {
    const scriptId = `structured-data-${id || type}`;
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    const structuredData = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };

    script.textContent = JSON.stringify(structuredData);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [type, data, id]);

  return null;
};

export default StructuredData;
